import { createContext, useContext } from "react";

/** True inside a modal, where a dropdown has to escape the scrolling body to be seen. */
const ModalContext = createContext(false);

export const ModalProvider = ModalContext.Provider;
export const useInModal = () => useContext(ModalContext);
